import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isProjectsDropdownOpen, setIsProjectsDropdownOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const toggleProjectsDropdown = () => {
    setIsProjectsDropdownOpen(!isProjectsDropdownOpen);
  };

  const handleProjectsClick = (e) => {
    // On mobile, toggle dropdown instead of scrolling
    if (window.innerWidth <= 768) {
      e.preventDefault();
      toggleProjectsDropdown();
    } else {
      // On desktop, scroll to projects section
      scrollToSection('projects');
    }
  };

  const scrollToSection = (sectionId) => {
    // If we're not on the home page, navigate there first
    if (location.pathname !== '/') {
      navigate('/');
      // Wait for navigation to complete, then scroll
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      // We're already on the home page, just scroll
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
    setIsMenuOpen(false);
    setIsProjectsDropdownOpen(false);
  };

  const navigateToProject = (path) => {
    navigate(path);
    setIsMenuOpen(false);
    setIsProjectsDropdownOpen(false);
  };

  return (
    <header className="header">
      <div className="container">
        <nav className="nav">
          <div className="nav-brand">
            <span className="brand-text">Ben Homer</span>
          </div>
          
          <div className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
            <a href="#home" onClick={() => scrollToSection('home')} className="nav-link">Home</a>
            <a href="#about" onClick={() => scrollToSection('about')} className="nav-link">About</a>
            <div className="nav-dropdown">
              <a 
                href="#projects" 
                onClick={handleProjectsClick} 
                className="nav-link"
                onMouseEnter={() => !isMenuOpen && setIsProjectsDropdownOpen(true)}
                onMouseLeave={() => !isMenuOpen && setIsProjectsDropdownOpen(false)}
              >
                Projects
              </a>
              <div 
                className={`dropdown-menu ${isProjectsDropdownOpen ? 'active' : ''}`}
                onMouseEnter={() => !isMenuOpen && setIsProjectsDropdownOpen(true)}
                onMouseLeave={() => !isMenuOpen && setIsProjectsDropdownOpen(false)}
              >
                <a 
                  href="#projects" 
                  onClick={() => scrollToSection('projects')} 
                  className="dropdown-item"
                >
                  All Projects
                </a>
                <a 
                  href="/smartcloset" 
                  onClick={() => navigateToProject('/smartcloset')} 
                  className="dropdown-item"
                >
                  SmartCloset
                </a>
                <a 
                  href="/tcgme" 
                  onClick={() => navigateToProject('/tcgme')} 
                  className="dropdown-item"
                >
                  TcgMe
                </a>
                <a 
                  href="/journeytomars" 
                  onClick={() => navigateToProject('/journeytomars')} 
                  className="dropdown-item"
                >
                  Journey To Mars
                </a>
                <a 
                  href="/recipebook" 
                  onClick={() => navigateToProject('/recipebook')} 
                  className="dropdown-item"
                >
                  RecipeBook
                </a>
                <a 
                  href="/spriteeditor" 
                  onClick={() => navigateToProject('/spriteeditor')} 
                  className="dropdown-item"
                >
                  Sprite Editor
                </a>
              </div>
            </div>
            <a href="#contact" onClick={() => scrollToSection('contact')} className="nav-link">Contact</a>
          </div>
          
          <div className="nav-toggle" onClick={toggleMenu}>
            <span className="bar"></span>
            <span className="bar"></span>
            <span className="bar"></span>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
